import {FilterInterface} from "@/views/Admin/Events/Event/Promocodes/Filter/Filter.interface";

export const FilterSchema: FilterInterface = {
    isLoading: false,
    data: {
        groups: {
            data: [],
            isLoading: false,
            meta: {
                currentPage: 1,
                from: 0,
                lastPage: 0,
                perPage: 10,
                to: 0,
                total: 0,
                sizes: {10: '10', 20: '20', 50: '50', 100: '100'}
            },
        },
        events: {
            data: [],
            isLoading: false,
            meta: {
                currentPage: 1,
                from: 0,
                lastPage: 0,
                perPage: 10,
                to: 0,
                total: 0,
                sizes: {10: '10', 20: '20', 50: '50', 100: '100'}
            },
        },
    },
    fields: {
        name: {
            label: 'Группа',
            placeholder: 'Введите группу',
            value: null,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
        promocode: {
            label: 'Промокод',
            placeholder: 'Введите промокод',
            value: null,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
        groupId: {
            label: 'Группы',
            placeholder: 'Не выбрано',
            value: null,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
            variants: {},
        },
        eventId: {
            label: 'События',
            placeholder: 'Не выбрано',
            value: null,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
            variants: {},
        },
        active: {
            label: 'Только активные',
            placeholder: null,
            value: null,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false
        },
    }
}
